export const toggleChatwoot = () => {
    if (window.$chatwoot && window.$chatwoot.hasLoaded) {
        if (!window.$chatwoot.isOpen) {
            window.$chatwoot.toggle("open")
        } else {
            window.$chatwoot.toggle("close")
        }
    }
}